import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { CUSTOM_BLUE, PALETTE_NEUTRAL_DARK } from 'utils/colours';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  filterChip: {
    margin: theme.spacing(0.5, 0.25, 0.5, 0.25),
    '& .MuiChip-label': {
      color: CUSTOM_BLUE,
      fontWeight: 600,
      fontSize: '1rem',
    },
  },
  filterCard: {
    padding: theme.spacing(1),
  },
  labelTitle: {
    fontWeight: 600,
    fontSize: '0.75rem',
    lineHeight: '16px',
    color: PALETTE_NEUTRAL_DARK,
  },
  clearFilters: {
    fontWeight: 600,
    fontSize: '0.875rem',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    marginLeft: theme.spacing(0.75),
  },
}));

export default useStyles;
